const RETURN_PATH_KEY = 'auth:returnPath';

/**
 * Accept only in-app paths so a logout redirect cannot send the browser off-site.
 */
export function sanitizeReturnPath(path: unknown): string | null {
  const raw = Array.isArray(path) ? path[0] : path;

  if (typeof raw !== 'string') {
    return null;
  }

  let value = raw.trim();

  if (!value) {
    return null;
  }

  try {
    value = decodeURIComponent(value);
  } catch {
    return null;
  }

  if (
    !value.startsWith('/')
    || value.startsWith('//')
    || value.includes('\\')
    || value.includes('://')
  ) {
    return null;
  }

  const pathOnly = value.split(/[?#]/)[0];

  if (
    pathOnly === '/login'
    || pathOnly.startsWith('/login/')
    || pathOnly.startsWith('/auth/social')
  ) {
    return null;
  }

  return value;
}

export function rememberReturnPath(path: unknown) {
  const safe = sanitizeReturnPath(path);

  if (!safe) {
    return;
  }

  try {
    sessionStorage.setItem(RETURN_PATH_KEY, safe);
  } catch {
    // Storage can be unavailable in private mode.
  }
}

export function consumeReturnPath(queryRedirect?: unknown): string | null {
  const fromQuery = sanitizeReturnPath(queryRedirect);
  let fromStorage: string | null = null;

  try {
    fromStorage = sanitizeReturnPath(sessionStorage.getItem(RETURN_PATH_KEY));
    sessionStorage.removeItem(RETURN_PATH_KEY);
  } catch {
    fromStorage = null;
  }

  return fromQuery || fromStorage;
}
